var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600",
        scrollable: "",
        persistent: "",
        eager: ""
      },
      on: {
        keydown: function keydown($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.close($event)
        },
        "click:outside": _vm.close
      },
      model: {
        value: _vm.dialogProxy,
        callback: function callback($$v) {
          _vm.dialogProxy = $$v
        },
        expression: "dialogProxy"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "app-card card-borderless"
        },
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Add User ")]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "pt-2 pb-3"
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [_vm._v(' Adding a User for "' + _vm._s(_vm.path) + '". ')]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: "User",
                          "data-vv-name": "uname",
                          "data-vv-as": "User",
                          autocomplete: "off",
                          "error-messages": _vm.errors.collect("uname")
                        },
                        on: {
                          keyup: function keyup($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addUser($event)
                          }
                        },
                        model: {
                          value: _vm.user,
                          callback: function callback($$v) {
                            _vm.user = $$v
                          },
                          expression: "user"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("compact-password", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "cpanel-app": "passwd",
                          "show-strength": "",
                          outlined: "",
                          label: "Password",
                          autocomplete: "off",
                          "data-vv-name": "password",
                          "data-vv-as": "Password",
                          "error-messages": _vm.errors.collect("password"),
                          "with-generator": ""
                        },
                        on: {
                          keyup: function keyup($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addUser($event)
                          }
                        },
                        model: {
                          value: _vm.password,
                          callback: function callback($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end pb-4 pt-0"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.addUser
                  }
                },
                [_vm._v("Add User")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }